export default __webpack_public_path__ + "static/media/send_light.a8c52046.svg";